import NotificationHolderComponent, 
from '@components/ehss/history/historyItem/body/notifications/NotificationHolderComponent';
import TasksHolderComponent from '@components/ehss/history/historyItem/body/tasks/TasksHolderComponent';
import BodyTitleComponent from '@components/history/historyItem/body/bodyTitleComponent';
import IWorkflow from '@interfaces/IWorkflow';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Avatar, Col, Row, Timeline } from 'antd';
import moment from 'moment';
import * as React from 'react';


interface ITimelineItemComponentProp {
  id: number;
  register: any;
  type: string;
  workflow?: IWorkflow;
  name?: string;
}

interface ITimelineItemComponentState {
  collapsed: boolean;
  tasks: any;
  localRegister: any;
}

export default class TimelineItemComponent extends React.Component<ITimelineItemComponentProp, ITimelineItemComponentState> {

  constructor(prop: ITimelineItemComponentProp) {
    super(prop);

    this.toggleCollapsed = this.toggleCollapsed.bind(this);

    this.state = {
      collapsed: true,
      tasks: undefined,
      localRegister: undefined,
    };

  }

  componentDidMount() {
    this.setState({ collapsed: false });
  }
  componentWillUpdate(props: any) {

  }

  private toggleCollapsed() {
    if (this.state.collapsed) {
      this.setState({
        collapsed: !this.state.collapsed,
        tasks: this.props.register.value.components,
      });
    } else {
      this.setState({
        collapsed: !this.state.collapsed,
        tasks: undefined,
      });
    }
  }

  private renderTimelineSignature(register: any, type: string) {
    const startAtDate: Date = new Date(register.startAt);
    const endAtDate: Date = new Date(register.startAt + register.duration);
    return (

      <div className="goepik-timeline-signature">
        <Row className="goepik-text-right">
          <Col sm={24} md={24} xl={24}>
            <p className="goepik-component-no-margin-bottom">
              {I18n.l('history.audits.labels.start')}
              &ensp;
                        {moment(startAtDate).format(I18n.l('common.dateTimeFormat'))}
            </p>
          </Col>
        </Row>
        {this.props.type === "process" && (
          <Row className="goepik-text-right">
            <Col sm={24} md={24} xl={24}>
              <p className="goepik-component-no-margin-bottom">
                {I18n.l('history.audits.labels.end')}
                &ensp;
                                        {moment(endAtDate).format(I18n.l('common.dateTimeFormat'))}
              </p>
            </Col>
          </Row>
        )}
      </div>

    );
  }

  private getProcessNameFromRegister(register: any, type: string) {
    if (!!this.props.name) {
      return this.props.name;
    }
    switch (type) {
      case "process": {
        return register.label || 'PROCESS TITLE';
      }

      case "notification": {
        return register.label || "NOTIFICATION TITLE";
      }

      default:
        return "errorOnType at GetProcessNameFromRegister";
    }
  }

  private getStatusFromRegister(register: any, type: string) {
    switch (type) {
      case "process":
        if (register.result) {
          return (
            <h4 className="goepik-status-done">
              {/* <Icon type="check-circle" /> */}
              {I18n.l('common.status')} "{I18n.l('global.ticket.ehss.status.done')}"
            </h4>
          );
        } else {
          return (
            <h4 className="goepik-status-error">
              {/* <Icon type="close-circle" /> */}
              {I18n.l('common.status')} "{I18n.l('global.ticket.ehss.status.error')}"
            </h4>
          );
        }

      case "notification":
        if (register.value.sent) {
          return (
            <h4 className="goepik-status-done">
              {/* <Icon type="check-circle" /> */}
              {I18n.l('common.status')} "{I18n.l('global.notification.status.done')}"
            </h4>
          );
        } else {
          return (
            <h4 className="goepik-status-error">
              {/* <Icon type="close-circle" /> */}
              {I18n.l('common.status')} "{I18n.l('global.notification.status.error')}"
            </h4>
          );
        }
      default:
        return <div>@Content not available</div>;
    }
  }

  renderContent() {

    const { register } = this.props;
    if (this.state.collapsed) {
      return (
        <Row className="goepik-side-padding-items">
          <Col sm={24} md={24} xl={24}>
            {
              ((this.props.type === "process") &&
                <TasksHolderComponent sections={register.value.sections} />
              )
            }{
              (this.props.type === "notification" &&
                <NotificationHolderComponent
                  body={register.value.content}
                  receivers={register.value.destinations}
                  notifyFailed={register.value.sent}
                />
              )
            }
          </Col>
        </Row>
      )
    }

    return;
  }

  public render() {
    const { register } = this.props;

    return (
      <GoEpikTimelineItem>
        <Timeline.Item key={this.props.id} dot={<Avatar className="goepik-timeline-number">{(this.props.id + 1)} </Avatar>}>
          {
            <Row className="goepik-side-padding">
              {this.renderTimelineSignature(register, this.props.type)}
            </Row>
          }
          <Row className="goepik-side-padding">
            <Col sm={24} md={24} xl={24}>
              <div className="goepik-clickable goepik-item-title" onClick={this.toggleCollapsed}>
                <BodyTitleComponent title={this.getProcessNameFromRegister(register, this.props.type)} collapsed={this.state.collapsed} />
              </div>
            </Col>
          </Row>
          {
            this.renderContent()
          }
        </Timeline.Item>

        <Timeline.Item className={"goepik-timeline-item-status"} color={Theme.primary.regular}>
          {this.getStatusFromRegister(register, this.props.type)}
        </Timeline.Item>

      </GoEpikTimelineItem>
    );
  }
}

const GoEpikTimelineItem = styled.div`
    .goepik-timeline-number{
        .ant-badge-count{
            background-color: #fff!important;
            color: ${Theme.primary.regular}!important;
            box-shadow: '0 0 0 1px #d9d9d9 inset!important'
        },
    }

    .ant-timeline-item {
        position: relative;
        padding: 0 0 20px;
        list-style: none;
        margin: 0;
        font-size: 14px;
        margin-left: 60px;
    }

    .ant-avatar {
        background: ${Theme.primary.regular}!important;
        color:${Theme.standard.white}!important;
        border-color:${Theme.primary.regular}!important;
    }

    .goepik-timeline-item-status{
        .ant-timeline-item-head{
            background-color: ${Theme.primary.regular}!important;
        }
    }

    .goepik-timeline-signature{
        min-height: 83px!important;
        position: absolute;
        padding-left: 45pxpx;
        padding-right: 24px;
        left: -18em;
        font-size: 14px;
    }

    .goepik-text-right{
        text-align: right;
    }

    .goepik-side-padding{
        padding-left: 24px!important;
        padding-right: 24px!important;
    }

    .goepik-side-padding-items{
        padding-left: 12px!important;
        padding-right: 24px!important;
    }

    .goepik-component-no-margin-bottom{
        margin-bottom: 0px!important;
    }

    .goepik-timeline-signature {
        min-height: 83px!important;
        position: absolute;
        padding-right: 24px;
        left: -18rem;
        font-size: 14px;
    }

    .goepik-item-title{
        font-size:16px;
    }

    .goepik-clickable{
        cursor: pointer;
    }
`;
